import { z } from 'zod';
import { requiredString } from '../../../../validation';

export const EndOfCareSummaryExpertSummarySchema = z.object({
  motivation: requiredString('Motivation and programme engagement is required'),
  progressAgainstGoals: requiredString(
    'Progress against goals and symptom/problem management is required',
  ),
  assessmentOfCapabilitiesReturnToWork: requiredString(
    'Assessment of capability to return back to work is required',
  ),
});

export type EndOfCareSummaryExpertSummary = z.infer<
  typeof EndOfCareSummaryExpertSummarySchema
>;
